import { loadLib, loadScript } from "../../utils/utils";
import { Globals } from "../../globals/variables";

export const loadD1C = () => {
  globalThis.idTagDelio = Globals.idTagD1C;

 loadLib("https://t.womtp.com/slider/c/delio-lm/dfi/init.js", Globals.idTagD1C)
};
